<template>
  <div
  class="info"
  :class="{'hidden' : !infoActive}"
  >
  <p>BREHMS WELT - Tiere und Menschen</p>
  <br>
  <p>
    IMPRESSUM <br>
    Projektleitung: <br>
    Prof. (a.D.). Dr. Jochen Süss<br>
    Projektassistenz: <br>
    Kim Janke, Thomas Peter, Ulrike Specht<br>
    Beratung (Beirat): <br>
    Volker Bauer<br>
    Catrin Eberhardt<br>
    Prof. Dr. Ferdinand von Eggeling<br>
    Prof. Dr. Dr. Martin S. Fischer<br>
    Enrico Hempel<br>
    Dr. Dietrich von Knorre<br>
    Dieter Müller<br>
    Holger Nowak<br>
  </p>
  <br>
  <p>
    RESTAURIERUNG BREHM-HAUS<br>
    Architektur:<br>
    Dieter Müller, Bad Berka<br>
    Organisatorische Betreuung:<br>
    Catrin Eberhardt<br>
    Farbfassungen und Rekonstruktion Tapeten:<br>
    Hans Joachim Frindte, Mühlhausen<br>
    Beatrix Kästner, Meusebach<br>
    Carina Schluckebier, Rotha<br>
    Lutz Seiler, Myra Lüers, Eisenberg<br>
    Lutz J. Walter, Wernigerode<br>
    Holzrestaurierung:<br>
    Matthias Krahnstöver, Kohren Sahlis<br>
    Karsten Skwierawski, Gera<br>
    Historische Polsterung:<br>
    Helge Löffler, Großdeuben<br>
    Lampenrestaurierung:<br>
    Wolfgang Schwarze, Blankenhain<br>
    Holzrestauratorische Arbeiten:<br>
    Lutz Scherf, Silbitz<br>
    Transkriptionen und Beratungen:<br>
    Roland Tittel, Seebergen<br>
    Mannfred Kanzner, Renthendorf<br>
    Restaurierung Metall, Uhren, Textilien:<br>
    Thomas Wurm und Stefanie Stroh, Erfurt<br>
    Spezialgrafik:<br>
    Robert Voss, Halle<br>
  </p>
  <br>
  <p>
    AUSSTELLUNG<br>
    Kurator: <br>
    Philipp Bürger, Köln<br>
    Ausstellung: <br>
    beier+wellach projekte , Berlin<br>
    Konzept, Gestaltung, Dramaturgie und künstlerische Bauleitung: <br>
    Ruudi Beier<br>
    Projektmanagement: <br>
    Birte Schramm<br>
    Entwurf und Planung: <br>
    Margaret Schlenkrich (Leitung), Ronja Schratzenstaller<br>
    Licht: <br>
    Christoph Kappeler, Dresden/Berlin<br>
    Leitgrafik, Ausstellungslayout und Textbuch: <br>
    Josefine Drager (Leitung), Katharina Buchhauser<br>
    Medien: <br>
    Michele Pedrazzi<br>
    Texte:<br>
    Philipp Bürger, Köln<br>
    Redaktion und Lektorat: <br>
    Florian Mittelbach (Leitung), Stephan Ahrens, Till Wagner<br>
    Frank Hauke, Berlin<br>
    Übersetzungen: <br>
    David Haney, Jena<br>
    Charlotte-Kathrin Stollberg (MSS Kapstadt)<br>
    Tierpräparation:<br>
    Matthias Krüger und Bernhard Leopold Bock, Phyletisches Museum, Jena<br>
    Szenografische Objekte: <br>
    Frank Fietzek, Berlin, <br>
    Stephan Hüsch, Berlin<br>
    Bauleitung und Medienplanung: <br>
    id3d-berlin, Jörg Scherrmann<br>
    Exponateinrichtung: <br>
    id3d-berlin, Ben Scherkus<br>
    Ausstellungsbau: <br>
    MKT-Möbelmanufaktur, Berlin<br>
    Grafikproduktion: <br>
    Pigmentpol Sachsen, Dresden<br>
    Animationen:<br>
    Yorgos Karagiorgos, Berlin<br>
    Filmaufnahmen Museum König, Bonn:<br>
    Marius von Bock und Nicolai Stein, Köln<br>
    Fotografie: <br>
    Roland Horn, Berlin<br>
    Buchrestaurierung und Faksimiles:<br>
    Christoph Roth, Leipzig<br>
    Frank Schieferdecker, Jena<br>
  </p>
  <br>
  <p>
    PEPPER‘S GHOST:<br>
    Produktionsleitung: <br>
    beier+wellach projekte, Berlin<br>
    Idee und Konzept: <br>
    Ruudi Beier<br>
    Kurator: <br>
    Philipp Bürger<br>
    Regie: <br>
    Katrin Nowak, Bielefeld<br>
    Drehbuch: <br>
    Ina Sparka, Düsseldorf<br>
    Darsteller*innen:<br>
    Jan Andressen als Alfred Edmund Brehm<br>
    Maske und Kostüm: <br>
    Jenny Wieland<br>
    Studio Babelsberg<br>
    Bühnenbau:<br>
    Id3d-berlin<br>
    Kamera, Ton und Postproduktion: <br>
    Michele Pedrazzi<br>
  </p>

  <p>
    MULTIMEDIAGUIDE: <br>
    BREHMS HÖRWELT <br>
    Produktionsleitung: <br>
    beier+wellach projekte, Berlin<br>
    Idee und Konzept: <br>
    Ruudi Beier<br>
    Kurator: <br>
    Philipp Bürger<br>
    Regie: <br>
    Katrin Nowak, Bielefeld<br>
    Sprecher*innen:<br>
    Dietmar Bär als Christian Ludwig Brehm<br>
    Jan Andressen als Alfred Edmund Brehm:<br>
    Barbara Krehl als Sprecherin<br>
    Tonstudio:<br>
    audioberlin, Berlin<br>
    Screenlayout: <br>
    Josefine Drager<br>
    Programmierung und Implementierung: <br>
    pluslab, Tom Hanke, Halle<br>
  </p>
  <br>
  <p>
    LEIHGEBER:<br>
    Friedrich-Schiller-Universität Jena | Phyletisches Museum<br>
    Dr. Harro Strehlow, Berlin<br>
    Hermann-Krone-Sammlung, IAPP, TU Dresden<br>
    Hörner/Antlfinger<br>
    Ina - Institut national de l'audiovisuel <br>
    Johannes Franck, Hermsdorf<br>
    Komitee gegen den Vogelmord e. V.<br>
    LWL-Medienzentrum für Westfalen<br>
    Museum Schloss Wilhelmsburg, Schmalkalden<br>
    Neozoon<br>
    ORF-Enterprise GmbH<br>
    Stadtgeschichtliches Museum Leipzig<br>
    Victoria &amp; Albert Museum, London<br>
    Zoo Leipzig GmbH<br>
  </p>
  <br>
  <p>
    DANKSAGUNG<br>
    Besonderer Dank gilt unseren Unterstützer*innen:<br>
    <ul>
      <li>Staatsministerin für Kultur und Medien bei der Bundeskanzlerin, Berlin</li>
      <li>Deutsche Stiftung Denkmalschutz, Bonn</li>
      <li>Hermann Reemtsma Stiftung, Hamburg</li>
      <li>Thüringer Landesamt für Denkmalpflege und Archäologie, Erfurt</li>
      <li>Thüringer Staatskanzlei, Erfurt</li>
      <li>Thüringer Ministerium für Bildung, Wissenschaft und Kultur, Erfurt</li>
      <li>Thüringer Ministerium für Umwelt, Energie und Naturschutz, Erfurt</li>
      <li>Thüringer Landesamt für Landwirtschaft und ländlichen Raum, Jena</li>
      <li>Friedrich-Schiller-Universität Jena, <br>
        Institut für Zoologie und Evolutionsforschung mit Phyletischem Museum etc.</li>
      <li>Thüringer Universitäts- und Landesbibliothek, Jena</li>
      <li>Kulturstiftung der Länder, Berlin</li>
      <li>Sparkassen-Kulturstiftung Hessen-Thüringen, Frankfurt! M./ Erfurt</li>
      <li>Sparkassen-Stiftung Jena Saale Holzland, Jena</li>
      <li>Sparkasse Jena Saale Holzland, Jena</li>
      <li>Bürgermeistern und Gemeinderäten des <br>
        Zweckverbandes Brehm-Gedenkstätte Renthendorf,Tröbnitz</li>
      <li>Verwaltungsgemeinschaft Hügelland/Täler, Tröbnitz</li>
      <li>Superintendent und Gemeindekirchenrat, Eisenberg und Renthendorf</li>
      <li>Förderkreis Brehm e.V., Renthendorf</li>
      <li>Verein Thüringer Ornithologen, Hildburghause</li>
      <li>Deutsche Ornithologen-Gesellschaft, Radolfzell</li>
      <li>Förderverein Denkmalpflege, Erfurt</li>
      <li>Landratsamt Saale Holzland, Eisenberg</li>
      <li>Katharina und Gerhard Hoffmann Stiftung, Hamburg</li>
      <li>Architekturbüro Müller und Lehmann, Bad Berka</li>
      <li>Koordinierungsstelle für die Erhaltung des schriftlichen Kulturguts (KEK)</li>
      <li>Staatsbibliothek zu Berlin - Preußischer Kulturbesitz, Berlin</li>
    </ul>
  </p>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'info',
  computed: {
    ...mapGetters(['infoActive']),
  },
};
</script>

<style scoped lang="scss">
.info {
  position: fixed;
  top: 14vh;
  top: calc(var(--vh, 1vh) * 14);
  width: 100vw;
  height: 77vh;
  height: calc(var(--vh, 1vh) * 77);
  padding: 10vw;
  box-sizing: border-box;
  background-color: #eee;
  background-color: var(--main-background-color);
  font-size: .9em;
  overflow-y: scroll;

  transform: translateY(0);
  transition: transform .5s ease;

  &.hidden {
    transform: translateY(87vh);
    transform: translateY(calc(var(--vh, 1vh) * 87));
  }
  ul {
    margin: 0;
    padding: 0;
    padding-left: 10px;
    list-style-type: none;

    li {
      text-indent: 0;
    }
    li:before {
      content: '- ';
      margin-left: -8px;
    }
  }
}
@media only screen and (orientation : portrait)
and (min-aspect-ratio: 4/9)
and (max-height : 700px) {
  .info {
  }
}
</style>
